'use strict';

function BikePublicIDTransformer(
	Util,
	jsonMapper,
	serviceResponseRepository,
	aggregatedRemoveService
) {
	var currentResponse = null;
	var driverUniqueIdCtr = 1;
	var historyUniqueIdCtr = 1;

	function forgePublicId(moduleName) {
		return Util.stringFormat(
			'portal:{0}-{1}',
			moduleName,
			Util.generateRandomString(15)
		);
	}

	function hasValidGWPublicID(publicID) {
		if (publicID && publicID.indexOf('portal:') === -1) return true;

		return false;
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if (currentResponse)
			return Util.findHierarchyStringInObject(currentResponse, path, '.');

		return null;
	}

	function convertPublicID(path, moduleName) {
		if (currentResponse) {
			var lastPublicID = fetchFromPreviousResponse(path);
			if (lastPublicID) return lastPublicID;
		}

		return forgePublicId(moduleName);
	}

	var moduleNameMapping = {
		policyHolders: 'PolicyHolder[]',
		policyAddress: 'Address',
		motorcycle: 'QPYMotorcycle',
		rider: 'QPYMotorcycleRider',
		policyRider: 'QPYPolicyRider',
		person: 'Person',
		modification: 'QPYCycleModification',
		accessories: 'QPYCycleAccessories',
		riderHistory: 'QPYRiderHistory',
		drivingHistory: 'DrivingHistory',
		pattern: 'qbePattern'
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.publicID': function() {
			return forgePublicId(moduleNameMapping.motorcycle);
		},
		'motorcycles.0.accountLocation.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.qpyCycleModifications.*.publicID': function() {
			return forgePublicId(moduleNameMapping.modification);
		},
		'motorcycles.0.qpyMotorcycleAccessories.*.publicID': function() {
			return forgePublicId(moduleNameMapping.accessories);
		},
		'motorcycles.0.riders.*.publicID': function() {
			return forgePublicId(moduleNameMapping.rider);
		},
		'motorcycles.0.riders.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'motorcycles.0.riders.*.rider.publicID': function() {
			return forgePublicId(moduleNameMapping.policyRider);
		},
		'motorcycles.0.riders.*.rider.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'motorcycles.0.riders.*.rider.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.riderHistory);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'policyHolders.*.contact.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.drivingHistory);
		}
	};

	var authorisedPersonsPublicIDTransformationMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID': function(val) {
			return convertPublicID(
				'policyAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.publicID': function(val) {
			return convertPublicID(
				'motorcycles.0.publicID',
				moduleNameMapping.motorcycle
			);
		},
		'motorcycles.0.riders.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'motorcycles.0.accountLocation.publicID': function(val) {
			return convertPublicID(
				'motorcycles.0.accountLocation.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.qpyCycleModifications.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.qpyCycleModifications.' +
					mappedValueStarIndex +
					'.publicID',
				moduleNameMapping.modifications
			);
		},
		'motorcycles.0.qpyMotorcycleAccessories.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.qpyMotorcycleAccessories.' +
					mappedValueStarIndex +
					'.publicID',
				moduleNameMapping.accessories
			);
		},
		'policyHolders.*.contact.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'policyHolders.' + mappedValueStarIndex + '.contact.publicID',
				moduleNameMapping.policyHolders
			);
		},
		'motorcycles.0.riders.*.publicID': function(val, mappedValueStarIndex) {
			return convertPublicID(
				'motorcycles.0.riders.' + mappedValueStarIndex + '.publicID',
				moduleNameMapping.rider
			);
		},
		'motorcycles.0.riders.*.rider.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.publicID',
				moduleNameMapping.policyRider
			);
		},
		'motorcycles.0.riders.*.rider.person.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.person.publicID',
				moduleNameMapping.person
			);
		},
		'motorcycles.0.riders.*.rider.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndices[0] +
					'.rider.riderHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.riderHistory
			);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolder.' +
					mappedValueStarIndices[0] +
					'.contact.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndex[0] +
					'.contact.drivingHistory.' +
					mappedValueStarIndex[1] +
					'.publicID',
				moduleNameMapping.drivingHistory
			);
		}
	};

	var authorisedPersonsPublicIDConversionMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.publicID',
				moduleNameMapping.person
			);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		}
	};

	function removeDeletedAdditionalRiders(transformedRequest) {
		var removedRiders = aggregatedRemoveService.getList()
			? aggregatedRemoveService.getList()['rider']
			: null;
		var savedRiders = fetchFromPreviousResponse('motorcycles.0.riders');
		if (savedRiders && removedRiders) {
			angular.forEach(removedRiders, function(removedRider) {
				var matchingRider = savedRiders.filter(function(rider) {
					return (
						rider.rider.person.firstName ==
							removedRider.person.firstName &&
						rider.rider.person.lastName ==
							removedRider.person.lastName
					);
				});
				matchingRider = matchingRider[0] || null;
				if (matchingRider) {
					matchingRider.markedForDelete = true;
					transformedRequest.motorcycles[0].riders.push(
						matchingRider
					);
				}
			});
			aggregatedRemoveService.clear('rider');
		}

		return transformedRequest;
	}

	function removeDeletedRiderHistoryArrays(transformedRequest) {
		var riders = transformedRequest.motorcycles[0].riders;
		angular.forEach(riders, function(rider, index) {
			var savedHistories = fetchFromPreviousResponse(
				'motorcycles.0.riders.' + index + '.rider.riderHistory'
			);
			if (savedHistories && savedHistories.length > 0) {
				var riderHistories = rider.rider.riderHistory;
				angular.forEach(savedHistories, function(savedHistory) {
					var matchingInput = riderHistories.filter(function(
						history
					) {
						return history.publicID == savedHistory.publicID;
					});
					if (!matchingInput || matchingInput.length == 0) {
						savedHistory.markedForDelete = true;
						riderHistories.push(savedHistory);
					}
				});
			}
		});
		return transformedRequest;
	}

	function removeEmptyRiderHistoryArrays(transformedRequest) {
		var motorcycle = transformedRequest.motorcycles[0];
		if (motorcycle && motorcycle.riders) {
			motorcycle.riders.forEach(function(policyRider) {
				if (
					policyRider.rider &&
					policyRider.rider.riderHistory &&
					Array.isArray(policyRider.rider.riderHistory) &&
					policyRider.rider.riderHistory.length == 0
				)
					delete policyRider.rider.riderHistory;
			});
		}

		return transformedRequest;
	}

	//dd-973 - requiring a sequence number for driver infringement
	function addUniqueHistoryID(transformedRequest) {
		var drivers = transformedRequest.motorcycles[0].riders;

		angular.forEach(drivers, function(driver, index) {
			historyUniqueIdCtr = 1;
			var driverHistory = driver.rider.riderHistory;
			if (driverHistory) {
				angular.forEach(driverHistory, function(driverHistory, index) {
					driverHistory.uniqueID = historyUniqueIdCtr;
					historyUniqueIdCtr++;
				});
			}
		});
		return transformedRequest;
	}

	function transform(intermediateRequest, response) {
		currentResponse = response;
		driverUniqueIdCtr = 1;
		var transformedRequest = intermediateRequest;

		if (
			transformedRequest.policyHolders[0] &&
			transformedRequest.policyHolders[0].contact &&
			transformedRequest.policyHolders[0].contact.authorisedPersons
		) {
			publicIDConversionMapping = Object.extend(
				publicIDConversionMapping,
				authorisedPersonsPublicIDConversionMapping
			);
			publicIDTransformationMapping = Object.extend(
				publicIDTransformationMapping,
				authorisedPersonsPublicIDTransformationMapping
			);
		}

		if (!currentResponse)
			transformedRequest = jsonMapper.transform(
				intermediateRequest,
				publicIDTransformationMapping
			);
		else {
			transformedRequest = jsonMapper.convert(
				intermediateRequest,
				publicIDConversionMapping
			);
		}

		transformedRequest = addUniqueHistoryID(transformedRequest);
		transformedRequest = removeDeletedAdditionalRiders(transformedRequest);
		transformedRequest = removeDeletedRiderHistoryArrays(
			transformedRequest
		);
		transformedRequest = removeEmptyRiderHistoryArrays(transformedRequest);

		return transformedRequest;
	}

	return {
		transform: transform
	};
}
